(function () {
  "use strict";

  angular
    .module("eltazkara.interceptor")
    .factory("authInterceptor", authInterceptor);

  authInterceptor.$inject = [
    "$localStorage",
    "$sessionStorage",
  ];

  function authInterceptor(
    $localStorage,
    $sessionStorage
  ) {
    var service = {
      request: request,
    };

    return service;

    function request(config) {
      /*jshint camelcase: false */
      config.headers = config.headers || {};

      var authData =
        $localStorage.authenticationToken ||
        $sessionStorage.authenticationToken;

      if (authData) {
        config.headers.Authorization = "Bearer " + authData.token;
        config.headers.AuthorizationRefesh = "Bearer " + authData.refreshToken;
      }

      return config;
    }
  }
})();
